/**
 * Azure Blob Storage Upload Service
 * Uploads files to Azure Blob Storage via the Node server
 */

import axios from "axios";
import setAuthToken from "../setAuthToken";
import { getNodeServerUrl } from "../../utils/getNodeUrl";

/**
 * Convert File object to base64 string
 * @param {File} file - The file to convert
 * @returns {Promise<string>}
 */
const convertFileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

/**
 * Upload file to Azure Blob Storage
 * @param {File} file - The file to upload
 * @param {string} folder - Folder path within container (e.g., "dealer-audit-bills")
 * @returns {Promise<{success: boolean, data: {url: string, fileName: string, folder: string}}>}
 */
export const uploadFileToBlobStorage = async (
  file,
  folder = "dealer-audit-bills",
) => {
  try {
    const nodeBaseUrl = getNodeServerUrl();
    const base64File = await convertFileToBase64(file);

    setAuthToken();

    const response = await axios.post(`${nodeBaseUrl}/blob/upload`, {
      file: base64File,
      fileName: file.name,
      folder: folder,
    });

    return response.data;
  } catch (error) {
    console.error("Error uploading file to blob storage:", error);
    throw error;
  }
};
